import React, { useCallback, useEffect } from 'react'
import {  BrowserRouter as Router } from 'react-router-dom';
import RouteRoute from './Routes';
import './App.css';
import AppTheme from './theme/AppTheme';
import { Toaster } from "sonner";
import { useDispatch } from 'react-redux';
import { logout } from './redux/Slice/AuthSlice';
import EventBus from './utils/EventBus';


function App(props) {
  const dispatch = useDispatch(); 

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
      EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [logOut]);

  return (
    <>
    <Toaster/>
    <AppTheme {...props}>
    <Router>
    <RouteRoute/>
    </Router>
    </AppTheme>
  </>
  );
}

export default App;